import { api } from "../apis/configs/axiosConfigs";

// Deliberately synchronous: it returns the eject function that
// AuthInterceptorSetup uses as its effect cleanup. Marking this `async` (it
// awaits nothing) made it return a Promise instead, so every unmount threw
// "cleanup is not a function" — fatal during a root teardown — and the
// interceptor was never ejected, so registrations accumulated.
export const setupAuthInterceptor = getAccessTokenSilently => {
  const requestInterceptor = api.interceptors.request.use(
    async config => {
      let token;
      try {
        token = await getAccessTokenSilently();
      } catch (error) {
        localStorage.clear();
        // window.location.reload();
        window.location.href = "/";
      }
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  return () => {
    api.interceptors.request.eject(requestInterceptor);
  };
};
